<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Settings':'settings'}]">
            Organizations
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-organization'].isAllowed"
                    :to="{name: 'add-organization'}"
                    class="btn btn-link">Add Organization<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    @completed="stopLoadingPage">
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no Organizations</span>
                        <span
                            slot="description">Click on the button below to add your first organization.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-organization'].isAllowed"
                                :to="{name: 'add-organization'}"
                                class="btn btn-link">Add Organization<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import organizationColumns from './organization-columns';

    export default {
        name: 'organizations',
        components: {
            vTitle, vNoContent, vIcon, Grid,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: organizationColumns,
            };
        },
        methods: {
            provider(params) {
                return this.$api(({companies}) => companies.getAll(params));
            },
        },
    };
</script>
